import { Signing } from "@credify/crypto";
import type { CredifyConfig } from "../types";
import ApiClient from "./apiClient";

export class CredifyClass {
  config: CredifyConfig;
  apiClient: ApiClient;
  signing: Signing;

  constructor(config: CredifyConfig, apiClient: ApiClient, signing: Signing) {
    this.config = config;
    this.apiClient = apiClient;
    this.signing = signing
  }
}

export enum ProductType {
  InsuranceHealthForIndividual = "insurance:health-insurance:for-individual",
  InsuranceHealthForGroup = "insurance:health-insurance:for-group",
  InsuranceAutomobileMotorbike = "insurance:automobile-insurance:motorbike",
  InsuranceAutomobileCar = "insurance:automobile-insurance:car",
  InsuranceHomeHomeowner = "insurance:home-insurance:for-homeowner",
  InsuranceHomeHouse = "insurance:home-insurance:for-house",
  InsuranceHomeRenter = "insurance:home-insurance:for-renter",

  ConsumerUnsecuredLoanCash = "consumer-financing:unsecured-loan:cash",
  ConsumerUnsecuredLoanCreditCard = "consumer-financing:unsecured-loan:credit-card",
  ConsumerUnsecuredLoanBnpl = "consumer-financing:unsecured-loan:bnpl",
  ConsumerUnsecuredLoanCdLoan = "consumer-financing:unsecured-loan:cd-loan",
  ConsumerSecuredLoanPayday = "consumer-financing:secured-loan:payday",
  ConsumerSecuredLoanPoFinancing = "consumer-financing:secured-loan:po-financing",

  CorporateUnsecuredLoanCash = "corporate-financing:unsecured-loan:cash",
  CorporateUnsecuredLoanCreditCard = "corporate-financing:unsecured-loan:credit-card",
  CorporateUnsecuredLoanBnpl = "corporate-financing:unsecured-loan:bnpl",
  CorporateUnsecuredLoanCdLoan = "corporate-financing:unsecured-loan:cd-loan",
  CorporateSecuredLoanPayday = "corporate-financing:secured-loan:payday",
  CorporateSecuredLoanPoFinancing = "corporate-financing:secured-loan:po-financing",

  CreditCardTraditional = "credit-card:traditional",
  CreditCardCBCC = "credit-card:cbcc",
}